/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/**
 * A function for the Beautiful Drag and Drop component that receives a drag end result
 * and returns the related entities with the sequence numbers ordered according to the indexes.
 * @param {Object} onDragEndResult - a drag result object {e.g. {
      draggableId: '42424242-59c4-48ac-af38-da3dd14f843c',
      source: { index: 3, droppableId: 'applicant' },
      destination: { droppableId: 'applicant', index: 0 }
      ...
    }}
 * @param {Array} formEntities - form entities with the original sequence numbers
 * @returns {Array} - form entities with the updated sequence numbers based on the drag result
 */
export function reSequenceFormEntities(onDragEndResult, formEntities) {
  const resultFormEntities = JSON.parse(JSON.stringify(formEntities));
  const { destination, source, draggableId } = onDragEndResult;
  if (!destination) {
    return resultFormEntities;
  }
  if (destination.droppableId === source.droppableId && destination.index === source.index) {
    return resultFormEntities;
  }
  const sourceEntity = resultFormEntities.filter(f => f.id === draggableId)[0];
  resultFormEntities.splice(source.index, 1);
  resultFormEntities.splice(destination.index, 0, sourceEntity);
  if (destination.index < source.index) {
    sourceEntity.sequenceNumber = destination.index;
    for (let i = destination.index; i <= source.index; i += 1) {
      resultFormEntities[i].sequenceNumber += 1;
    }
  } else {
    // equality checked above
    sourceEntity.sequenceNumber = destination.index + 1;
    for (let i = source.index; i < destination.index; i += 1) resultFormEntities[i].sequenceNumber -= 1;
  }

  return resultFormEntities;
}

export function reSequenceFormEntitiesOnDeletion(deletedSequenceNumber, formEntities) {
  const resultFormEntities = formEntities;
  for (let i = 0; i < resultFormEntities.length; i += 1) {
    if (resultFormEntities[i].sequenceNumber > deletedSequenceNumber) {
      resultFormEntities[i].sequenceNumber -= 1;
    }
  }
  return resultFormEntities;
}
